<div class="organization-settings-controls">
    <div class="print-option-row">
        <h2 class="options-title">{{ 'aumico_annual_report_print_options_design_settings_title' | i18next }}</h2>
    </div>
    <div class="colorPickerContainer">
        <span class="color-box">
            <label for="textColor">{{ 'aumico_reports_print_text_color' | i18next }}</label>
            <input type="color" [formControl]="form.get('styleOptions')['controls']['textColor']" name="textColor" />
        </span>
        <span class="color-box">
            <label for="backgroundColor">{{ 'aumico_reports_print_highlight_color_1' | i18next }}</label>
            <input
                type="color"
                [formControl]="form.get('styleOptions')['controls']['backgroundColor']"
                name="backgroundColor"
            />
        </span>
        <span class="color-box">
            <label for="titleColor">{{ 'aumico_reports_print_title_color' | i18next }}</label>
            <input type="color" [formControl]="form.get('styleOptions')['controls']['titleColor']" name="titleColor" />
        </span>
    </div>
</div>
<div class="previewTable">
    <h2 [style.color]="form.get('styleOptions')['controls']['titleColor'].value">1.0 Example Table</h2>

    <div>
        <table>
            <thead>
                <tr>
                    <th [style.color]="form.get('styleOptions')['controls']['textColor'].value"></th>
                    <th
                        [style.backgroundColor]="form.get('styleOptions')['controls']['backgroundColor'].value"
                        [style.color]="form.get('styleOptions')['controls']['textColor'].value"
                    >
                        {{ currentYearDate |dateLocale}}
                    </th>
                    <th [style.color]="form.get('styleOptions')['controls']['textColor'].value">
                        {{ previousYearDate |dateLocale}}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td [style.color]="form.get('styleOptions')['controls']['textColor'].value">
                        This is a example row
                    </td>
                    <td
                        [style.backgroundColor]="form.get('styleOptions')['controls']['backgroundColor'].value"
                        [style.color]="form.get('styleOptions')['controls']['textColor'].value"
                    >
                        {{ 1000 | finNumber }}
                    </td>
                    <td [style.color]="form.get('styleOptions')['controls']['textColor'].value">
                        {{ 1000 | finNumber }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
